import { useMutation, useQueryClient } from "@tanstack/react-query";
import { facilityPhotosKeys } from "Api/Queries/Merchants/useGetFacilityPhotosQuery";
import { merchantKeys } from "Api/Queries/Merchants/useGetMerchantQuery";
import {
  type FacilityPhotoType,
  deleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoType,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type DeleteFacilityPhotoVariables = {
  merchantPublicID: string;
  facilityPublicID: string;
  photoType: FacilityPhotoType;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteFacilityPhotoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({
        merchantPublicID,
        facilityPublicID,
        photoType,
      }: DeleteFacilityPhotoVariables) =>
        deleteMerchantsPublicIDFacilitiesFacilityPublicIDPhotosPhotoType(
          merchantPublicID,
          facilityPublicID,
          photoType,
        ),
    ),
    onSuccess: (
      _,
      { merchantPublicID, facilityPublicID }: DeleteFacilityPhotoVariables,
    ) => {
      queryClient.invalidateQueries({ queryKey: merchantKeys.all });
      queryClient.invalidateQueries({
        queryKey: facilityPhotosKeys.byIds(merchantPublicID, facilityPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
